import {
  Component,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
  NgZone,
  Attribute,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output
} from '@angular/core'

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms'

export const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ToggleComponent),
  multi: true,
}

@Component({
  selector: 'toggle',
  styleUrls: ['toggle.component.less'],
  templateUrl: 'toggle.component.html',
  providers: [
    VALUE_ACCESSOR
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ToggleComponent implements ControlValueAccessor, AfterViewInit {
  @Input() label: string
  @Input() disabled = false
  @Output() modelChange = new EventEmitter<any>()

  private modelValue: boolean

  @ViewChild('elementRef') elementRef: ElementRef
  $element: any

  onChange: Function | null

  constructor(
    @Attribute('class') public classes,
    private ngZone: NgZone
  ) {}

  ngAfterViewInit() {
    this.$element = $(this.elementRef.nativeElement)
    this.ngZone.runOutsideAngular(() => {
      this.$element.checkbox()
    })
  }

  writeValue(modelValue: boolean) {
    this.modelValue = modelValue
    setTimeout(() => {
      this.ngZone.run(() => {
        if (modelValue) {
          this.$element.checkbox('set checked')
        } else {
          this.$element.checkbox('set unchecked')
        }
      })
    })
  }

  toggle(checked) {
    if (this.onChange && this.modelValue !== checked) {
      this.modelValue = checked
      this.onChange(checked)
      this.modelChange.emit(checked)
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled
  }

  registerOnTouched(fn: any) { }
}
